<ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: linkLists }"></ng-container>

<ng-template #recursiveList let-linkLists>
  <div class="link-list__group" *ngFor="let linkList of linkLists; let i = index">
    <ng-container *ngIf="linkList.links.length > 0">
      <ng-container *ngTemplateOutlet="pageLinks; context: { $implicit: linkList.links, listIndex: i }"></ng-container>
    </ng-container>
    <ng-container *ngIf="linkList.linkSections && linkList.linkSections.length > 0">
      <div class="link-list__section" *ngFor="let section of linkList.linkSections as ILinkSection" (click)="onSectionClick($event)">
        <div class="link-list__section__item">
          <i *ngIf="section.icon && section.icon !== ''" class="icon icon-{{ section.icon }}"></i>
          <span class="link-list__section__title">{{ section.title }}</span>
        </div>
        <ul class="link-list">
          <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: section.linkLists }"></ng-container>
        </ul>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #pageLinks let-links let-listIndex>
  <ul class="link-list__links">
    <li
      class="link-list__links__item"
      *ngFor="let link of links as IPageLink; let i = index"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <a [airLink]="link" [userEventSource]="userEventSource">
        <span>{{ link.label }}</span>
        <i *ngIf="link.icon && link.icon !== ''" class="icon icon-{{ link.icon }}"></i>
      </a>
    </li>
  </ul>
</ng-template>
